import loadable from '@loadable/component';

export const OrgDashboardRenewVolopPageContainerLoadable = loadable(
  () => import('./OrgDashboardRenewVolopPageContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardRenewVolopPageContainer,
    ssr: false,
  },
);
